import * as types from './mutation-types'

const mutations = {
  [types.SET_EVENTLIST](state, eventlist) {
    state.eventlist = eventlist
  },
  [types.SET_SEARCH](state, search) {
    state.search = search
    state.page = 1;
  },
  [types.SET_TOTAL](state, total) {
    state.total = total
  },
  [types.SET_DATE_RANGE](state, range) {
    state.date_range = range
    state.search = ''
    state.page = 1;
  },
  [types.SET_CLEAR_ALL](state) {
    state.search = ''
    state.date_range = {
      type: '',
      start: '',
      end: ''
    };
    state.page = 1;
  },
  [types.SET_LOADING](state, loading) {
    state.loading = loading;
  },
  [types.SET_PAGE](state, page) {
    state.page = page;
  },
  [types.SET_MONTH_EVENTS](state, month_events) {
    state.month_events = month_events;
  },
  [types.SET_CATEGORY_LIST](state, categorylist) {
    state.categorylist = categorylist;
  },
  [types.SET_FILTER](state, filter) {
    state.filter = filter;
  }
}

export default mutations
